import { memo } from 'react';

import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';
import { DownloadIcon, ImportIcon } from '@/components/icons';

export type ManualLogoProps = Omit<LogoProps, 'variant'> & {
  type: 'trigger' | 'export';
};

const IManualLogo = ({ type, className, ...rest }: ManualLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      {type === 'trigger' ? (
        <ImportIcon className="!text-primary-700" />
      ) : (
        <DownloadIcon className="!text-primary-700" />
      )}
    </Logo>
  );
};

export const ManualLogo = memo(IManualLogo) as typeof IManualLogo;
